"use client";

import { useEffect } from "react";
import { useFormContext } from "react-hook-form";

import { AddressInput } from "@/components/ui";

import { cx } from "@/lib/tailwind-utils";

interface AddressFieldProps {
  className?: string;
  onAddressChange?: (addressData: any) => void;
  required?: boolean;
  label?: string;
  idPrefix?: string;
  includeCoordinates?: boolean;
}

export default function AddressField({
  className,
  onAddressChange,
  required = false,
  label = "Address",
  idPrefix = "",
  includeCoordinates = false,
}: AddressFieldProps) {
  const { watch } = useFormContext();

  // Watch for changes in address fields and call onAddressChange
  useEffect(() => {
    if (onAddressChange) {
      const subscription = watch((value, { name }) => {
        if (
          name?.includes("address") ||
          name?.includes("city") ||
          name?.includes("state") ||
          name?.includes("zipCode") ||
          name?.includes("latitude") ||
          name?.includes("longitude")
        ) {
          const addressData = {
            address: value[idPrefix + "address"],
            addressLineTwo: value[idPrefix + "addressLineTwo"],
            city: value[idPrefix + "city"],
            state: value[idPrefix + "state"],
            zipCode: value[idPrefix + "zipCode"],
            country: "US",
            ...(value[idPrefix + "latitude"] && {
              latitude: value[idPrefix + "latitude"],
            }),
            ...(value[idPrefix + "longitude"] && {
              longitude: value[idPrefix + "longitude"],
            }),
          };
          onAddressChange(addressData);
        }
      });
      return () => subscription.unsubscribe();
    }
  }, [watch, onAddressChange]);

  return (
    <div className={cx("w-full", className)}>
      <AddressInput
        required={required}
        namePrefix={idPrefix}
        label={label}
        includeCoordinates={includeCoordinates}
      />
    </div>
  );
}
